// 这个保留，后期可能需要单独添加地区的选择器
// 如果是这样就将RegionAndLanguageSelect组件中的region组件抽离出来

import React, { useEffect, useState } from 'react';
import type { RegionType } from '../../types';
import { commonBackInfo, compareArraysEqual } from '../../utils';
import {
  accountRegionTitleLocal,
  kolRegionTitleLocal,
  popularList,
  regionRadioOptions,
  regionTitleLocal,
} from '../../constants/regionAndLanguage';
import NewRegionSelect from '@/pages/home/components/NewRegionSelect';
import { getCountryFlag } from '@/pages/home/_config/countries';
import useDefaultTwoLevelFilter from '../../hooks/useDefaultTwoLevelFilter';
import { useIntl } from 'umi';
import { addFilterBuriedPoint } from '../../utils/point';
import { FilterButtonPoint } from '@op/operationLog/pages/filter';
import './index.scss';

const regionGlobalTipsMap: { common: string; influencer: string } = {
  common:
    'Global refers to the reviews from game store and social media, which cannot be distinguished from regions/countries.',
  influencer: 'Global data includes Influencer with no country/region defined.',
};

const regionglobalWoChinaTipsMap: { common: string; influencer: string } = {
  common:
    'Global except China mainland refers to the reviews from game store and social media, that are collected from all regions/countries except China mainland, which cannot be distinguished from regions/countries.',
  influencer:
    'Global except China mainland refers to the reviews from game store and social media, that are collected from all regions/countries except China mainland, which cannot be distinguished from regions/countries.',
};

export default function KolRegionSelect({
  changeOnCloseWindow,
  onChange,
  defaultValue,
  filterValue,
  defaultKey,
  lang,
  filterOptions,
  oriDefaultFilter,
  regionGolobalTipsKey = 'common',
  regionglobalWoChinaKey = 'common',
}: RegionType) {
  const [regionOptions, setRegionOPtions] = useState<Array<any>>([]);
  // const regionOptions = useMemo(() => {}, [filterOptions]);
  const { formatMessage } = useIntl();
  useEffect(() => {
    let region: Array<any> = [];
    if (filterOptions) {
      const localFilterOptions =
        filterOptions.region_country || filterOptions || [];

      const list =
        localFilterOptions?.map?.(
          ({ region_key, country, region_name_cn, region_name_en }: any) => ({
            value: region_key?.toLocaleLowerCase?.(),
            text: region_name_en,
            textCN: region_name_cn,
            children: (country || [])?.map?.(
              ({
                country_name_abbre,
                country_name_cn,
                country_name_en,
              }: any) => ({
                value: country_name_abbre?.toLocaleLowerCase?.(),
                text: country_name_en,
                textCN: country_name_cn,
                icon: getCountryFlag(country_name_abbre),
              }),
            ),
          }),
        ) || [];

      list?.unshift({
        value: 'unidentified',
        textCN: '未区分国家/地区',
        text: 'Unidentified',
        children: [
          {
            value: 'Unidentified',
            textCN: '未区分国家/地区',
            text: 'Unidentified',
          },
        ],
      });
      region = list;
    }
    setRegionOPtions(region);
  }, [filterOptions]);
  const {
    setSelectValue,
    selectValue,
    onChange: onRegionChange,
    diffClassName,
  } = useDefaultTwoLevelFilter({
    originalOptions: regionOptions,
    defaultValue,
    filterValue,
    oriDefaultFilter,
    dealwithDefaultValue: (value: any) => {
      let { region, region_type } = value || {
        region: [],
        region_type: 'market',
      };
      let marketsValue: 'global' | 'global_wo_china' = 'global';
      region = region?.filter((item: string) => item !== 'global');
      const globalWoChinaValue = regionOptions
        .map((item) => item.value)
        .filter((item) => item !== 'chn');
      if (compareArraysEqual(globalWoChinaValue, region)) {
        marketsValue = 'global_wo_china';
        region = [];
      }

      return { value: region || [], type: region_type, marketsValue };
    },
    onlySecondLevelValue: true
  });

  const regionChange = (tags: any) => {
    setSelectValue(tags);
  };

  function getCommonBackInfo() {
    const { value, isGLOBAL_WO_CHINA } = onRegionChange(selectValue);

    // 处理一下“未区分国家的评论”选项
    const index = value.indexOf('Unidentified');
    if (index > -1) value.splice(index, 1, 'global');

    if (isGLOBAL_WO_CHINA) {
      const localFilterOptions = filterOptions.region_country || filterOptions || [];
      const list = localFilterOptions
        .filter((val) => value?.includes(val.region_key?.toLocaleLowerCase?.())) // filter items not in value
        .flatMap((val) =>
          val.country?.map((c) => c.country_name_abbre?.toLowerCase?.()) || []
        );
      return commonBackInfo(
        {
          kol_countrys: list,
        },
        {
          kol_countrys: list.length,
        },
      );
    }

    return commonBackInfo(
      {
        kol_countrys: value,
      },
      {
        kol_countrys: value.length === 0 ? 'All' : value.length,
      },
    );
  }

  useEffect(() => {
    onChange?.('kol_countrys', getCommonBackInfo());
  }, [selectValue, formatMessage]);

  useEffect(() => {
    const data = getCommonBackInfo();
    changeOnCloseWindow?.(data.value);
  }, [selectValue]);

  return (
    <div className={`region-select-wrapper ${diffClassName}`}>
      <NewRegionSelect
        popularList={popularList}
        locale={lang}
        language={kolRegionTitleLocal}
        radioOptions={regionRadioOptions(regionGolobalTipsKey)}
        value={selectValue}
        options={regionOptions}
        radioOptionsTips={{
          global: formatMessage({
            id: regionGlobalTipsMap[regionGolobalTipsKey],
          }),
          global_wo_china: formatMessage({
            id: regionglobalWoChinaTipsMap[regionglobalWoChinaKey],
          }),
        }}
        closeOnScroll={true}
        onCloseReginSelect={(result: any) => {
          regionChange(result);

          try {
            const { value: selectValue, type } = onRegionChange(result);
            // 处理一下“未区分国家的评论”选项
            const index = selectValue.indexOf('Unidentified');
            if (index > -1) selectValue.splice(index, 1, 'global');

            // addFilterBuriedPoint(FilterButtonPoint.region, {
            //   region: selectValue,
            //   region_type: type,
            // });
          } catch (error) { }
        }}
      // onChange={(value: any) => regionChange(value)}
      />
    </div>
  );
}
